import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class PromoSlider extends Component {
  #timer = 0;
  #indice = 0;
  #osservatore = null;

  connectedCallback() {
    super.connectedCallback();
    this.slides = [...this.querySelectorAll('.megamenu__promo-slide')];
    if (this.slides.length < 2 || this.dots) return;

    this.#creaPallini();

    // col puntatore sopra la card l autoplay si ferma: chi sta leggendo non se la vede cambiare
    this.addEventListener('pointerenter', () => this.#ferma());
    this.addEventListener('pointerleave', () => this.#parti());
    this.addEventListener('focusin', () => this.#ferma());
    this.addEventListener('focusout', (evento) => {
      if (!this.contains(evento.relatedTarget)) this.#parti();
    });

    // il pannello del menu nasce hidden: quando si apre lo slider entra in viewport e riparte
    // dalla prima, altrimenti riaprendo il menu si ritroverebbe la slide lasciata a meta
    this.#osservatore = new IntersectionObserver((voci) => {
      for (const voce of voci) {
        if (voce.isIntersecting) {
          this.#vai(0);
          this.#parti();
        } else {
          this.#ferma();
        }
      }
    });
    this.#osservatore.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#osservatore?.disconnect();
    this.#ferma();
  }

  #creaPallini() {
    const barra = document.createElement('div');
    barra.className = 'megamenu__promo-dots';
    this.dots = this.slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'megamenu__promo-dot';
      const nome = slide.querySelector('.megamenu__promo-eyebrow')?.textContent.trim();
      dot.setAttribute('aria-label', nome || String(i + 1));
      if (i === 0) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      }
      dot.addEventListener('click', () => this.#vai(i));
      barra.append(dot);
      return dot;
    });
    this.append(barra);
  }

  #parti() {
    if (prefersReducedMotion()) return;
    this.#ferma();
    // 0 secondi dal theme editor = autoplay spento, restano i pallini
    const attesa = Number(this.dataset.interval);
    if (!attesa) return;
    this.#timer = setInterval(() => this.#vai(this.#indice + 1), attesa);
  }

  #ferma() {
    clearInterval(this.#timer);
    this.#timer = 0;
  }

  #vai(quale) {
    this.#indice = (quale + this.slides.length) % this.slides.length;
    this.slides.forEach((s, i) => {
      const attiva = i === this.#indice;
      s.classList.toggle('is-active', attiva);
      if (attiva) s.removeAttribute('aria-hidden');
      else s.setAttribute('aria-hidden', 'true');
    });
    this.dots.forEach((d, i) => {
      const attiva = i === this.#indice;
      d.classList.toggle('is-active', attiva);
      if (attiva) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('promo-slider')) customElements.define('promo-slider', PromoSlider);
